
import { Box, Button, CircularProgress, styled } from "@mui/material";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {
    List,
    Datagrid,
    TextField,
    TextInput,
    TopToolbar,
    SelectInput,
    DateField,
    useDataProvider,
    FunctionField,
    useNotify,
    useRefresh,
    useListContext
} from "react-admin";
import { useState } from "react";
import DownloadIcon from '@mui/icons-material/Download';
import { ErrorDetailsDialog } from "../../Components/ErrorDetailsDialog"; // 导入新的对话框组件

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


const ListActions = () => {
    const { setFilters, filterValues } = useListContext();  // 获取列表上下文
    const initialFilters = {};  // 初始过滤器值

    // 重置过滤器函数
    const handleResetFilters = () => {
        setFilters(initialFilters);
    };

    const dataProvider = useDataProvider(); // 获取数据提供者
    const notify = useNotify(); // 获取通知方法
    const [isUploading, setIsUploading] = useState(false); // 上传状态
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [importResult, setImportResult] = useState<{
        successCount: number;
        failCount: number;
        failedRecords: Array<any>;
    } | null>(null);

    const refresh = useRefresh();

    // 处理文件上传
    const handleFileUpload = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        setIsUploading(true);

        try {
            // 调用批量导入接口
            let { data } = await dataProvider.macImport('storeProduct', {
                data: {
                    file,
                    // totalCount: 100
                }
            });
            refresh();  // 触发列表刷新

            // 保存导入结果
            setImportResult({
                successCount: data.successCount || 0,
                failCount: data.failCount || 0,
                failedRecords: data.failedRecords || []
            });

            if (data.failCount > 0) {
                setErrorDialogOpen(true);
            } else {
                notify(`导入成功: 共 ${data.successCount} 个MAC地址`, {
                    type: 'success',
                    autoHideDuration: 3000
                });
            }

        } catch (error) {
            setImportResult({
                successCount: 0,
                failCount: 0,
                failedRecords: []
            });
            setErrorDialogOpen(true);
        } finally {
            setIsUploading(false);
            // 重置文件输入，允许重复上传同一文件
            event.target.value = null;
        }
    };

    const handleCloseErrorDialog = () => {
        setErrorDialogOpen(false);
    };

    const templateUrl = "https://iot-edge-dev.oss-cn-heyuan.aliyuncs.com/templates/MAC_template.txt";
    return (
        <>
            <TopToolbar sx={{ alignItems: "center" }}>
                <Button
                    onClick={handleResetFilters}
                    disabled={Object.keys(filterValues).length === 0}
                >
                    重置搜索
                </Button>
                <Button
                    size="small"
                    component="a"
                    href={templateUrl}
                    download="导入MAC地址模板.xlsx"
                    startIcon={<DownloadIcon />}
                    sx={{ ml: 1 }}
                >
                    下载模板
                </Button>
                <Button
                    component="label"
                    size="small"
                    startIcon={isUploading ? <CircularProgress size={16} /> : <FileUploadIcon />}
                    disabled={isUploading}
                >
                    {isUploading ? '导入中...' : '导入MAC地址'}
                    <VisuallyHiddenInput
                        type="file"
                        accept=".txt,.xls,.xlsx"
                        onChange={handleFileUpload}
                        disabled={isUploading}
                    />
                </Button>
            </TopToolbar>

            {/* 错误详情对话框 */}
            <ErrorDetailsDialog
                open={errorDialogOpen}
                onClose={handleCloseErrorDialog}
                failedRecords={importResult?.failedRecords || []}
                successCount={importResult?.successCount || 0}
                failCount={importResult?.failCount || 0}
            />
        </>
    );
};


export const MACAddressList = () => {
    let postFilters = [
        <TextInput label="MAC地址" alwaysOn source="mac" />,
        <SelectInput
            alwaysOn
            key="used"
            source="used"
            label="使用状态"
            choices={[
                { id: 1, name: '已使用' },
                { id: 0, name: '未使用' }
            ]}
        />
    ];


    return (
        <List filters={postFilters} actions={<ListActions />} empty={false}>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id" label="ID" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="mac" label="MAC" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="snId" label="SN ID" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <DateField source="createTime" label="创建日期" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <FunctionField
                    label="使用状态"
                    render={(record) => {
                        return <Box>{record.used ? '已使用' : '未使用'}</Box>;
                    }}
                />
            </Datagrid>
        </List>
    )
}